import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, injectIntl} from 'react-intl';

import apiCalls from '../../utils/apiCalls';
import utils from '../../utils/utils';

import GeneralForm from "../../components/generalForm";
import {connect} from "react-redux";
import RichText from "../../components/customFields/richText";
import RefundCalculator from "./refundCalculator";

const RefundForm = ({intl, order, payment, closeModal}) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showOrderItemCalculation, setShowOrderItemCalculation] = useState(true);
  const [refundProperties, setRefundProperties] = useState({
    email: {},
    includeEmail: false,
    paymentRefund: {},
  });

  useEffect(() => {
    setError(null);
    setLoading(true);
    const userId = order ? order.user.id : payment.user.id;
    apiCalls.getUsersAdmin({
      userId: userId,
    })
      .then((result) => {
        const newEmail = refundProperties.email;
        const newUser = result.data.users[0];
        newEmail.to = newUser.contact;
        newEmail.body = `
          ${intl.formatMessage({id: 'email.form.order.refund.default.body.p1'}, {
          userName: newUser ? newUser.firstName || newUser.screenName : ''
        })}
          <br><br>${intl.formatMessage({id: 'email.form.order.refund.default.body.p2'}, {
          marketplaceName: order ? order.marketplaceName : ''
        })}
          <br><br>
          ${intl.formatMessage({id: 'email.form.order.refund.default.body.p3'})}
        `;

        const newRefundProps = refundProperties;
        newRefundProps.email = newEmail;
        setRefundProperties(newRefundProps);
        setLoading(false);
      })
      .catch((errors) => {
        setError(utils.getErrorMessageFromResponse(errors));
        setLoading(false);
      });
  }, [order]);

  const formSchema = {
    type: "object",
    required: [],
    properties: {
      paymentRefund: {
        title: intl.formatMessage({id: 'payment.refund.form.title'}),
        type: "object",
        required: [],
        properties: {
          amount: {
            type: "string",
            title: intl.formatMessage({id: 'payment.refund.form.field.amount.label'}),
            default: "0",
          },
          comment: {
            type: "string",
            title: intl.formatMessage({id: 'payment.refund.form.field.comment.label'}),
            default: '',
          },
        }
      },
      includeEmail: {
        type: "boolean",
        title: intl.formatMessage({id: 'payment.refund.form.field.include.email'}),
      },
      email: {
        title: intl.formatMessage({id: 'email.form.title'}),
        type: "object",
        required: [],
        properties: {
          subject: {
            type: "string",
            title: intl.formatMessage({id: 'email.form.field.subject.label'}),
            default: intl.formatMessage({id: 'email.form.order.refund.default.subject'}, {orderId: order ? order.batchId : ''}),
          },
          body: {
            type: "string",
            title: intl.formatMessage({id: 'email.form.field.body.label'}),
            default: '',
          },
          to: {
            type: "string",
            title: intl.formatMessage({id: 'email.form.field.to.label'}),
            default: ''
          },
        }
      }
    }
  }

  if (order) {
    formSchema.properties.paymentRefund.properties.orderId = {
      type: "string",
      title: intl.formatMessage({id: 'payment.refund.form.field.order.id.label'}),
      default: order ? order.id.toString() : '',
    };
  } else {
    formSchema.properties.paymentRefund.properties.paymentId = {
      type: "string",
      title: intl.formatMessage({id: 'payment.refund.form.field.payment.id.label'}),
      default: payment ? payment.id.toString() : '',
    };
  }

  if (!refundProperties.includeEmail) {
    delete formSchema.properties.email;
  }

  const uiSchema = {
    paymentRefund: {
      amount: {
        "ui:help": intl.formatMessage({id: 'payment.refund.form.field.amount.help'}),
      },
      orderId: {
        "ui:help": intl.formatMessage({id: 'payment.refund.form.field.order.id.help'}),
      },
    },
    email: {
      body: {
        "ui:field": "richText",
      },
    }
  };

  function onFormSubmit() {
    setLoading(true);

    apiCalls.createPaymentRefund(refundProperties)
      .then((result) => {
        setLoading(false);
        const successCopy = result.data.email ? 'payment.refund.form.create.success.alert.with.email' :
          'payment.refund.form.create.success.alert.no.email';

        alert(intl.formatMessage({id: successCopy}));
        closeModal();
      })
      .catch((error) => {
        setLoading(false);
        setError(utils.getErrorMessageFromResponse(error, true));
        window.scrollTo(0, 0);
      });
  }

  const buttonCopy = 'refund.create.form.submit';

  const formFields = {
    richText: RichText,
  };

  const header = intl.formatMessage({id: 'refund.create.header'});

  return (
    <div className="row">
      <div className="col-12 col-lg-10 offset-lg-1 admin__form">
        {
          order? (
            <div className="m-b-3">
              <button className="btn btn-normal-link" onClick={() => setShowOrderItemCalculation(!showOrderItemCalculation)}>
                <FormattedMessage id={showOrderItemCalculation?
                  'refund.create.order.item.calculator.trigger.hide': 'refund.create.order.item.calculator.trigger.show'}/>
              </button>
            </div>
          ): ''
        }
        {showOrderItemCalculation && order ? (
          <RefundCalculator order={order}/>
        ) : ''}

        <GeneralForm title={header}
                     onChange={(event) => setRefundProperties(event.formData)}
                     onSubmit={onFormSubmit}

                     formSchema={formSchema}
                     formUiSchema={uiSchema}
                     formFields={formFields}

                     formData={refundProperties}

                     buttonCopy={buttonCopy}
                     errorMessage={error}
                     loading={loading}
                     hideImageUpload={true}
        />
      </div>
    </div>
  );
}

RefundForm.propTypes = {
  order: PropTypes.object,
  payment: PropTypes.object,
  closeModal: PropTypes.func.isRequired,
};

RefundForm.defaultProps = {};

function mapStateToProps(state) {
  return {};
}

export default injectIntl(connect(mapStateToProps)(RefundForm));